export default __webpack_public_path__ + "static/media/art-pro-blk-poster-2.a3dd21c3.jpg";